import React from 'react';
import TaskRow from './TaskRow';
import EmptyState from '../shared/EmptyState';
import Pagination from '../shared/Pagination';

function TasksList({ tasks, meta, page, onPageChange, onTaskClick }) {
  if (!tasks.length) {
    return <EmptyState icon="✅" title="Sin tareas" description="Ajusta los filtros o captura nuevas tareas enviando un predicado." />;
  }
  return (
    <div>
      <div className="list-container">
        {tasks.map(t => (
          <TaskRow key={t.id} task={t} onClick={() => onTaskClick(t)} />
        ))}
      </div>
      <Pagination page={page} totalPages={meta?.totalPages || 1} onPageChange={onPageChange} />
    </div>
  );
}

export default TasksList;
